/* eslint-disable import/first, import/newline-after-import */

import 'components/global/promos/promo-popup';
import 'components/util/sales-event/sales-event';
import 'components/util/sale-toast/sale-toast';
import 'components/global/site-banners/site-banner';
import 'components/customer-feedbacks/customer-feedback';

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import { featureEnabled } from 'lib/helpers'; // eslint-disable-line import/order

import(
  /* webpackChunkName: "partner-popup-controller" */
  /* webpackPreload: true */
  'components/partner/partner-popup-controller'
).then((controller) => {
  EezyStimulusApplication.register('partner-popup', controller.default);
});

import PromoPopupController from 'components/global/promos/promo-popup-controller';
EezyStimulusApplication.register('promo-popup', PromoPopupController);

import CountdownTimerController from 'components/util/countdown-timer/countdown-timer-controller';
EezyStimulusApplication.register('countdown-timer', CountdownTimerController);

if (featureEnabled('customer-feedback')) {
  import(
    /* webpackChunkName: "customer-feedback-modal-controller" */
    /* webpackPrefetch: true */
    'components/customer-feedbacks/customer-feedback-modal-controller'
  ).then((controller) => {
    EezyStimulusApplication.register('customer-feedback-modal', controller.default);
  });

  import(
    /* webpackChunkName: "customer-feedback-form-controller" */
    /* webpackPrefetch: true */
    'components/customer-feedbacks/customer-feedback-form-controller'
  ).then((controller) => {
    EezyStimulusApplication.register('customer-feedback-form', controller.default);
  });
}
